import React from 'react'

const Aboutus = () => {
  return (
    <div>
      <div
  className="breadcumb-wrapper"
  style={{
    backgroundImage: "url('assets/img/bg/breadcumb-bg.jpg')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  }}
>

        <div class="container">
            <div class="breadcumb-content">
                <h1 class="breadcumb-title">About Avighna Energy solutions</h1>
                <ul class="breadcumb-menu">
                    <li><a href="/">Home</a></li>
                    <li>About Us</li>
                </ul>
            </div>
        </div>
    </div>
       <div class="about-area position-relative overflow-hidden space" id="about-sec">
        <div class="container">
            <div class="row">
                <div class="col-xl-6 col-xxl-7">
                    <div class="img-box2">
                        <div class="img1 reveal"><img src="assets/img/normal/about_2_1.jpg" alt="About"/></div>
                        <div class="img2 wow fadeInUp"><img src="assets/img/normal/about_2_2.jpg" alt="About"/> <a
                                href="https://www.youtube.com/watch?v=pQpFebyALV0" class="play-btn popup-video"><i
                                    class="fa-sharp fa-solid fa-play"></i></a></div>
                    </div>
                </div>
                <div class="col-xl-6 col-xxl-5">
                    <div class="">
                        <div class="title-area about4-titlebox mb-20"><span
                                class="sub-title style1 text-anime-style-2">About Us</span>
                            <h2 class="sec-title mb-20 text-anime-style-2">Innovate Faster, Scale Smarter with Us</h2>
                        </div>
                        <p class="sec-text mb-30 wow fadeInUp" data-wow-delay=".2s">A Startup Tech Agency specializes in
                            providing innovative, scalable, and customized technology solutions to help startups build,
                            grow, and succeed in a competitive market.</p>
                        <div class="about-item-wrap">
                            <div class="about-item wow fadeInUp" data-wow-delay=".2s">
                                <div class="about-item_img"><img src="assets/img/icon/map3.svg" alt=""/></div>
                                <div class="about-item_centent">
                                    <h5 class="box-title">Manage Tech Services</h5>
                                    <p class="about-item_text">There are many variations of passages of available but
                                        the majority.</p>
                                </div>
                            </div>
                            <div class="about-item wow fadeInUp" data-wow-delay=".3s">
                                <div class="about-item_img"><img src="assets/img/icon/guide.svg" alt=""/></div>
                                <div class="about-item_centent">
                                    <h5 class="box-title">Internal Networking</h5>
                                    <p class="about-item_text">There are many variations of passages of available but
                                        the majority.</p>
                                </div>
                            </div>
                            <div class="about-item wow fadeInUp" data-wow-delay=".4s">
                                <div class="about-item_img"><img src="assets/img/icon/headphone.svg" alt=""/></div>
                                <div class="about-item_centent">
                                    <h5 class="box-title">24/7 Customer Support</h5>
                                    <p class="about-item_text">There are many variations of passages of available but
                                        the majority.</p>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
     <section class="process-area py-5 text-center bg-light">
  <div class="container">
    <div class="mb-5">
      <span class="d-block text-primary fs-5 fw-semibold">Our Process</span>
      <h2 class="display-6 fw-bold">How It Work Process!</h2>
    </div>

    <div class="row g-4">
      {/* <!-- Step 01 --> */}
      <div class="col-sm-6 col-lg-3">
        <div class="card shadow-sm h-100 border-0 animate__animated animate__fadeInUp animate__delay-1s">
          <img 
  src="assets/img/process/process_1_1.jpg"
  alt="Planning"
  className="card-img-top img-fluid p-3"
  style={{ height: '150px', objectFit: 'contain' }}
/>

          <div class="card-body">
            <h5 class="card-title">Planning</h5>
            <p class="card-text small">Identify and create relevant features that enhance the model's performance.</p>
            <p class="fw-bold text-primary">STEP - 01</p>
          </div>
        </div>
      </div>

      {/* <!-- Step 02 --> */}
      <div class="col-sm-6 col-lg-3">
        <div class="card shadow-sm h-100 border-0 animate__animated animate__fadeInUp animate__delay-2s">
          <img src="assets/img/process/process_1_2.jpg" alt="Design & Execution" class="card-img-top img-fluid p-3"  style={{ height: '150px', objectFit: 'contain' }}/>
          <div class="card-body">
            <h5 class="card-title">Design & Execution</h5>
            <p class="card-text small">Retrain the model with new data to maintain relevance and effectiveness.</p>
            <p class="fw-bold text-primary">STEP - 02</p>
          </div>
        </div>
      </div>

      {/* <!-- Step 03 --> */}
      <div class="col-sm-6 col-lg-3">
        <div class="card shadow-sm h-100 border-0 animate__animated animate__fadeInUp animate__delay-3s">
          <img src="assets/img/process/process_1_3.jpg" alt="Monitoring" class="card-img-top img-fluid p-3"  style={{ height: '150px', objectFit: 'contain' }} />
          <div class="card-body">
            <h5 class="card-title">Monitoring</h5>
            <p class="card-text small">Integrate the trained model into the desired platform, application, or system.</p>
            <p class="fw-bold text-primary">STEP - 03</p>
          </div>
        </div>
      </div>

      {/* <!-- Step 04 --> */}
      <div class="col-sm-6 col-lg-3">
        <div class="card shadow-sm h-100 border-0 animate__animated animate__fadeInUp animate__delay-4s">
          <img src="assets/img/process/process_1_4.jpg" alt="Report & Sign-out" class="card-img-top img-fluid p-3"  style={{ height: '150px', objectFit: 'contain' }} />
          <div class="card-body">
            <h5 class="card-title">Report & Sign-out</h5>
            <p class="card-text small">Incorporate user feedback and system outcomes for iterative improvements.</p>
            <p class="fw-bold text-primary">STEP - 04</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<div className="video-1-area py-5">
  <div className="container">
    <div
      className="video2-wrapp position-relative rounded text-center"
      style={{
        backgroundImage: "url('assets/img/bg/video_bg_3.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '300px',
      }}
    >
      <div className="video-box1 position-absolute top-50 start-50 translate-middle">
        <a
          href="https://www.youtube.com/watch?v=tBG2ZfKYwao"
          className="btn btn-light rounded-circle shadow"
          style={{
            width: '70px',
            height: '70px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fa fa-play text-primary fs-4"></i>
        </a>
      </div>
    </div>
  </div>
</div>

    <div class="history-sec1 overflow-hidden space-bottom" id="story-sec">
        <div class="container">
            <div class="row gy-4 justify-content-center">
                <div class="col-xl-4 col-md-6">
                    <div class="story-box inner-style"><span class="story-box_icon"><img
                                src="assets/img/icon/history_1_1.svg" alt=""/></span>
                        <h3 class="box-title">Our Mission</h3>
                        <p class="story-box_text mb-0">It involves adopting modern technologies such as cloud computing,
                            artificial intelligence (AI), data analytics, automation, and the Internet of Things (IoT)
                            to enhance efficiency, customer experiences, and overall business performance.</p>
                    </div>
                </div>
                <div class="col-xl-4 col-md-6">
                    <div class="story-box inner-style"><span class="story-box_icon"><img
                                src="assets/img/icon/history_1_2.svg" alt=""/></span>
                        <h3 class="box-title">Our Vision</h3>
                        <p class="story-box_text mb-0">It involves adopting modern technologies such as cloud computing,
                            artificial intelligence (AI), data analytics, automation, and the Internet of Things (IoT)
                            to enhance efficiency, customer experiences, and overall business performance.</p>
                    </div>
                </div>
                <div class="col-xl-4 col-md-6">
                    <div class="story-box inner-style"><span class="story-box_icon"><img
                                src="assets/img/icon/history_1_3.svg" alt=""/></span>
                        <h3 class="box-title">Our Goal</h3>
                        <p class="story-box_text mb-0">It involves adopting modern technologies such as cloud computing,
                            artificial intelligence (AI), data analytics, automation, and the Internet of Things (IoT)
                            to enhance efficiency, customer experiences, and overall business performance.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="counter-sec2 space-bottom">
        <div class="container">
            <div class="row gy-4 align-items-center justify-content-center">
                <div class="col-md-6 col-xl-3">
                    <div class="counter-card style2 inner-style">
                        <div class="counter-shape"><span></span></div>
                        <div class="media-body">
                            <h3 class="box-number text-white"><span class="counter-number">08</span></h3>
                            <h6 class="counter-title text-white">Years Experience</h6>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-xl-3">
                    <div class="counter-card style2 inner-style">
                        <div class="counter-shape"><span></span></div>
                        <div class="media-body">
                            <h3 class="box-number text-white"><span class="counter-number">97</span>%</h3>
                            <h6 class="counter-title text-white">Retention Rate</h6>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-xl-3">
                    <div class="counter-card style2 inner-style">
                        <div class="counter-shape"><span></span></div>
                        <div class="media-body">
                            <h3 class="box-number text-white"><span class="counter-number">5</span>k</h3>
                            <h6 class="counter-title text-white">Project Completed</h6>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-xl-3">
                    <div class="counter-card style2 inner-style">
                        <div class="counter-shape"><span></span></div>
                        <div class="media-body">
                            <h3 class="box-number text-white"><span class="counter-number">2</span>k</h3>
                            <h6 class="counter-title text-white">Happy Clients</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="shape-mockup jump d-none d-xl-block" data-bottom="20%" data-left="5%"><img
                src="assets/img/shape/shape_5.png" alt="shape"/></div>
    </div>
    {/* <section class="team-area8 overflow-hidden bg-smoke space" id="testi-sec">
        <div class="container-fluid p-0">
            <div class="title-area mb-20 text-center"><span class="sub-title text-anime-style-2">Our Team Memners</span>
                <h2 class="sec-title text-anime-style-3">Meet Our Expert Members</h2>
            </div>
            <div class="slider-area">
                <div class="swiper th-slider teamSlider8 has-shadow" id="teamSlider8"
                    data-slider-options='{"breakpoints":{"0":{"slidesPerView":3},"767":{"slidesPerView":"3"},"992":{"slidesPerView":"3"},"1200":{"slidesPerView":"4"},"1400":{"slidesPerView":"5"}}}'>
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="th-team team-grid2">
                                <div class="team-img">
 <img
  src="assets/img/team/team_3_1.jpg"
  alt="Team"
  style={{
    width: '120px',
    height: '120px',
    objectFit: 'cover',
    borderRadius: '10px'
  }}
/>

</div>

                                <div class="team-content">
                                    <h3 class="box-title"><a href="team-guider-details.html">Jacob Jones</a></h3>
                                    <div class="th-social"><a href="https://www.facebook.com/"><i
                                                class="fab fa-facebook-f"></i></a> <a
                                            href="https://www.linkedin.com/"><i class="fab fa-linkedin-in"></i></a> <a
                                            href="https://www.twitter.com/"><i class="fab fa-twitter"></i></a> <a
                                            href="https://www.youtube.com/"><i class="fab fa-youtube"></i></a></div>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="th-team team-grid2">
                                <div class="team-img"><img src="assets/img/team/team_3_2.jpg" alt="Team"/></div>
                                <div class="team-content">
                                    <h3 class="box-title"><a href="team-guider-details.html">Jane Cooper</a></h3>
                                    <div class="th-social"><a href="https://www.facebook.com/"><i
                                                class="fab fa-facebook-f"></i></a> <a
                                            href="https://www.linkedin.com/"><i class="fab fa-linkedin-in"></i></a> <a
                                            href="https://www.twitter.com/"><i class="fab fa-twitter"></i></a> <a
                                            href="https://www.youtube.com/"><i class="fab fa-youtube"></i></a></div>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="th-team team-grid2">
                                <div class="team-img"><img src="assets/img/team/team_3_3.jpg" alt="Team"/></div>
                                <div class="team-content">
                                    <h3 class="box-title"><a href="team-guider-details.html">Jason Vermate.</a></h3>
                                    <div class="th-social"><a href="https://www.facebook.com/"><i
                                                class="fab fa-facebook-f"></i></a> <a
                                            href="https://www.linkedin.com/"><i class="fab fa-linkedin-in"></i></a> <a
                                            href="https://www.twitter.com/"><i class="fab fa-twitter"></i></a> <a
                                            href="https://www.youtube.com/"><i class="fab fa-youtube"></i></a></div>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="th-team team-grid2">
                                <div class="team-img"><img src="assets/img/team/team_3_4.jpg" alt="Team"/></div>
                                <div class="team-content">
                                    <h3 class="box-title"><a href="team-guider-details.html">Jenny Wilson</a></h3>
                                    <div class="th-social"><a href="https://www.facebook.com/"><i
                                                class="fab fa-facebook-f"></i></a> <a
                                            href="https://www.linkedin.com/"><i class="fab fa-linkedin-in"></i></a> <a
                                            href="https://www.twitter.com/"><i class="fab fa-twitter"></i></a> <a
                                            href="https://www.youtube.com/"><i class="fab fa-youtube"></i></a></div>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="th-team team-grid2">
                                <div class="team-img"><img src="assets/img/team/team_3_5.jpg" alt="Team"/></div>
                                <div class="team-content">
                                    <h3 class="box-title"><a href="team-guider-details.html">Jacob Jones</a></h3>
                                    <div class="th-social"><a href="https://www.facebook.com/"><i
                                                class="fab fa-facebook-f"></i></a> <a
                                            href="https://www.linkedin.com/"><i class="fab fa-linkedin-in"></i></a> <a
                                            href="https://www.twitter.com/"><i class="fab fa-twitter"></i></a> <a
                                            href="https://www.youtube.com/"><i class="fab fa-youtube"></i></a></div>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="th-team team-grid2">
                                <div class="team-img"><img src="assets/img/team/team_3_1.jpg" alt="Team"/></div>
                                <div class="team-content">
                                    <h3 class="box-title"><a href="team-guider-details.html">Jacob Jones</a></h3>
                                    <div class="th-social"><a href="https://www.facebook.com/"><i
                                                class="fab fa-facebook-f"></i></a> <a
                                            href="https://www.linkedin.com/"><i class="fab fa-linkedin-in"></i></a> <a
                                            href="https://www.twitter.com/"><i class="fab fa-twitter"></i></a> <a
                                            href="https://www.youtube.com/"><i class="fab fa-youtube"></i></a></div>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="th-team team-grid2">
                                <div class="team-img"><img src="assets/img/team/team_3_2.jpg" alt="Team"/></div>
                                <div class="team-content">
                                    <h3 class="box-title"><a href="team-guider-details.html">Jane Cooper</a></h3>
                                    <div class="th-social"><a href="https://www.facebook.com/"><i
                                                class="fab fa-facebook-f"></i></a> <a
                                            href="https://www.linkedin.com/"><i class="fab fa-linkedin-in"></i></a> <a
                                            href="https://www.twitter.com/"><i class="fab fa-twitter"></i></a> <a
                                            href="https://www.youtube.com/"><i class="fab fa-youtube"></i></a></div>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="th-team team-grid2">
                                <div class="team-img"><img src="assets/img/team/team_3_3.jpg" alt="Team"/></div>
                                <div class="team-content">
                                    <h3 class="box-title"><a href="team-guider-details.html">Jason Vermate.</a></h3>
                                    <div class="th-social"><a href="https://www.facebook.com/"><i
                                                class="fab fa-facebook-f"></i></a> <a
                                            href="https://www.linkedin.com/"><i class="fab fa-linkedin-in"></i></a> <a
                                            href="https://www.twitter.com/"><i class="fab fa-twitter"></i></a> <a
                                            href="https://www.youtube.com/"><i class="fab fa-youtube"></i></a></div>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="th-team team-grid2">
                                <div class="team-img"><img src="assets/img/team/team_3_4.jpg" alt="Team"/></div>
                                <div class="team-content">
                                    <h3 class="box-title"><a href="team-guider-details.html">Jenny Wilson</a></h3>
                                    <div class="th-social"><a href="https://www.facebook.com/"><i
                                                class="fab fa-facebook-f"></i></a> <a
                                            href="https://www.linkedin.com/"><i class="fab fa-linkedin-in"></i></a> <a
                                            href="https://www.twitter.com/"><i class="fab fa-twitter"></i></a> <a
                                            href="https://www.youtube.com/"><i class="fab fa-youtube"></i></a></div>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="th-team team-grid2">
                                <div class="team-img"><img src="assets/img/team/team_3_5.jpg" alt="Team"/></div>
                                <div class="team-content">
                                    <h3 class="box-title"><a href="team-guider-details.html">Jacob Jones</a></h3>
                                    <div class="th-social"><a href="https://www.facebook.com/"><i
                                                class="fab fa-facebook-f"></i></a> <a
                                            href="https://www.linkedin.com/"><i class="fab fa-linkedin-in"></i></a> <a
                                            href="https://www.twitter.com/"><i class="fab fa-twitter"></i></a> <a
                                            href="https://www.youtube.com/"><i class="fab fa-youtube"></i></a></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="slider-pagination"></div>
                </div>
            </div>
        </div>
    </section> */}
     {/* <section class="testi-area overflow-hidden space" id="testi-sec">
        <div class="container-fluid p-0">
            <div class="title-area mb-20 text-center"><span class="sub-title text-anime-style-2">Testimonial</span>
                <h2 class="sec-title text-anime-style-3">What Client Say About us</h2>
            </div>
            <div class="slider-area">
                <div class="swiper th-slider testiSlider1 has-shadow" id="testiSlider1"
                    data-slider-options='{"breakpoints":{"0":{"slidesPerView":1},"767":{"slidesPerView":"1","centeredSlides":"true"},"992":{"slidesPerView":"2","centeredSlides":"true"},"1200":{"slidesPerView":"2.5","centeredSlides":"true"},"1400":{"spaceBetween":5,"slidesPerView":"2.5","centeredSlides":"true"}}}'>
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                           <div class="testi-card"style={{
  maxWidth: '280px',
  padding: '20px',
  fontSize: '14px'
}}
>
  <div class="testi-card_wrapper">
    <div class="testi-card_profile">
      <div class="testi-card_avater">
        <img
          src="assets/img/testimonial/testi_1_1.jpg"
          alt="testimonial"
         style={{
  width: '60px',
  height: '60px',
  objectFit: 'cover',
  borderRadius: '50%'
}}

        />
      </div>
      <div class="media-body">
        <h3 class="box-title"style={{ fontSize: '16px' }}
>Maria Doe</h3>
        <span class="testi-card_desig" style={{ fontSize: '12px' }}
>UI/UX Designer</span>
      </div>
    </div>
    <div class="testi-card_review" style={{ fontSize: '12px' }}
>
      <i class="fa-solid fa-star"></i>
      <i class="fa-solid fa-star"></i>
      <i class="fa-solid fa-star"></i>
      <i class="fa-solid fa-star"></i>
      <i class="fa-solid fa-star"></i>
    </div>
  </div>
  <p class="testi-card_text" style={{ fontSize: '13px', lineHeight: 1.5 }}
>
    “IT consulting services are designed to help businesses optimize their technology strategies, streamline operations...”
  </p>
  <div class="testi-card-quote">
    <img
      src="assets/img/icon/testi-quote.svg"
      alt="img"
     style={{ width: '25px', height: '25px' }}

    />
  </div>
</div>

                        </div>
                        <div class="swiper-slide">
                            <div class="testi-card">
                                <div class="testi-card_wrapper">
                                    <div class="testi-card_profile">
                                        <div class="testi-card_avater"><img src="assets/img/testimonial/testi_1_2.jpg"
                                                alt="testimonial"/></div>
                                        <div class="media-body">
                                            <h3 class="box-title">Andrew Simon</h3><span
                                                class="testi-card_desig">Front-End Developer</span>
                                        </div>
                                    </div>
                                    <div class="testi-card_review"><i class="fa-solid fa-star"></i> <i
                                            class="fa-solid fa-star"></i> <i class="fa-solid fa-star"></i> <i
                                            class="fa-solid fa-star"></i> <i class="fa-solid fa-star"></i></div>
                                </div>
                                <p class="testi-card_text">“IT consulting services are designed to help businesses
                                    optimize their technology strategies, streamline operations, and align IT solutions
                                    with their goal. Here are some key service offered under IT consulting Assisting
                                    with cloud migration.”</p>
                                <div class="testi-card-quote"><img src="assets/img/icon/testi-quote.svg" alt="img"/>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="testi-card">
                                <div class="testi-card_wrapper">
                                    <div class="testi-card_profile">
                                        <div class="testi-card_avater"><img src="assets/img/testimonial/testi_1_3.jpg"
                                                alt="testimonial"/></div>
                                        <div class="media-body">
                                            <h3 class="box-title">Alex Jordan</h3><span class="testi-card_desig">Backend
                                                Engineer</span>
                                        </div>
                                    </div>
                                    <div class="testi-card_review"><i class="fa-solid fa-star"></i> <i
                                            class="fa-solid fa-star"></i> <i class="fa-solid fa-star"></i> <i
                                            class="fa-solid fa-star"></i> <i class="fa-solid fa-star"></i></div>
                                </div>
                                <p class="testi-card_text">“IT consulting services are designed to help businesses
                                    optimize their technology strategies, streamline operations, and align IT solutions
                                    with their goal. Here are some key service offered under IT consulting Assisting
                                    with cloud migration.”</p>
                                <div class="testi-card-quote"><img src="assets/img/icon/testi-quote.svg" alt="img"/>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="testi-card">
                                <div class="testi-card_wrapper">
                                    <div class="testi-card_profile">
                                        <div class="testi-card_avater"><img src="assets/img/testimonial/testi_1_2.jpg"
                                                alt="testimonial"/></div>
                                        <div class="media-body">
                                            <h3 class="box-title">Maria Doe</h3><span class="testi-card_desig">Python
                                                Developer</span>
                                        </div>
                                    </div>
                                    <div class="testi-card_review"><i class="fa-solid fa-star"></i> <i
                                            class="fa-solid fa-star"></i> <i class="fa-solid fa-star"></i> <i
                                            class="fa-solid fa-star"></i> <i class="fa-solid fa-star"></i></div>
                                </div>
                                <p class="testi-card_text">“IT consulting services are designed to help businesses
                                    optimize their technology strategies, streamline operations, and align IT solutions
                                    with their goal. Here are some key service offered under IT consulting Assisting
                                    with cloud migration.”</p>
                                <div class="testi-card-quote"><img src="assets/img/icon/testi-quote.svg" alt="img"/>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="testi-card">
                                <div class="testi-card_wrapper">
                                    <div class="testi-card_profile">
                                        <div class="testi-card_avater"><img src="assets/img/testimonial/testi_1_1.jpg"
                                                alt="testimonial"/></div>
                                        <div class="media-body">
                                            <h3 class="box-title">Angelina Rose</h3><span class="testi-card_desig">PHP
                                                Developer</span>
                                        </div>
                                    </div>
                                    <div class="testi-card_review"><i class="fa-solid fa-star"></i> <i
                                            class="fa-solid fa-star"></i> <i class="fa-solid fa-star"></i> <i
                                            class="fa-solid fa-star"></i> <i class="fa-solid fa-star"></i></div>
                                </div>
                                <p class="testi-card_text">“IT consulting services are designed to help businesses
                                    optimize their technology strategies, streamline operations, and align IT solutions
                                    with their goal. Here are some key service offered under IT consulting Assisting
                                    with cloud migration.”</p>
                                <div class="testi-card-quote"><img src="assets/img/icon/testi-quote.svg" alt="img"/>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="testi-card">
                                <div class="testi-card_wrapper">
                                    <div class="testi-card_profile">
                                        <div class="testi-card_avater"><img src="assets/img/testimonial/testi_1_3.jpg"
                                                alt="testimonial"/></div>
                                        <div class="media-body">
                                            <h3 class="box-title">Maria Doe</h3><span class="testi-card_desig">Django
                                                Developer</span>
                                        </div>
                                    </div>
                                    <div class="testi-card_review"><i class="fa-solid fa-star"></i> <i
                                            class="fa-solid fa-star"></i> <i class="fa-solid fa-star"></i> <i
                                            class="fa-solid fa-star"></i> <i class="fa-solid fa-star"></i></div>
                                </div>
                                <p class="testi-card_text">“IT consulting services are designed to help businesses
                                    optimize their technology strategies, streamline operations, and align IT solutions
                                    with their goal. Here are some key service offered under IT consulting Assisting
                                    with cloud migration.”</p>
                                <div class="testi-card-quote"><img src="assets/img/icon/testi-quote.svg" alt="img"/>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="testi-card">
                                <div class="testi-card_wrapper">
                                    <div class="testi-card_profile">
                                        <div class="testi-card_avater"><img src="assets/img/testimonial/testi_1_2.jpg"
                                                alt="testimonial"/></div>
                                        <div class="media-body">
                                            <h3 class="box-title">Andrew Simon</h3><span
                                                class="testi-card_desig">JavaScrip Developer</span>
                                        </div>
                                    </div>
                                    <div class="testi-card_review"><i class="fa-solid fa-star"></i> <i
                                            class="fa-solid fa-star"></i> <i class="fa-solid fa-star"></i> <i
                                            class="fa-solid fa-star"></i> <i class="fa-solid fa-star"></i></div>
                                </div>
                                <p class="testi-card_text">“IT consulting services are designed to help businesses
                                    optimize their technology strategies, streamline operations, and align IT solutions
                                    with their goal. Here are some key service offered under IT consulting Assisting
                                    with cloud migration.”</p>
                                <div class="testi-card-quote"><img src="assets/img/icon/testi-quote.svg" alt="img"/>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="testi-card">
                                <div class="testi-card_wrapper">
                                    <div class="testi-card_profile">
                                        <div class="testi-card_avater"><img src="assets/img/testimonial/testi_1_1.jpg"
                                                alt="testimonial"/></div>
                                        <div class="media-body">
                                            <h3 class="box-title">Alex Jordan</h3><span class="testi-card_desig">App
                                                Developer</span>
                                        </div>
                                    </div>
                                    <div class="testi-card_review"><i class="fa-solid fa-star"></i> <i
                                            class="fa-solid fa-star"></i> <i class="fa-solid fa-star"></i> <i
                                            class="fa-solid fa-star"></i> <i class="fa-solid fa-star"></i></div>
                                </div>
                                <p class="testi-card_text">“IT consulting services are designed to help businesses
                                    optimize their technology strategies, streamline operations, and align IT solutions
                                    with their goal. Here are some key service offered under IT consulting Assisting
                                    with cloud migration.”</p>
                                <div class="testi-card-quote"><img src="assets/img/icon/testi-quote.svg" alt="img"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="slider-pagination"></div>
                </div>
            </div>
        </div>
        <div class="shape-mockup th-line-shape d-none d-xl-block" data-bottom="-2%" data-right="0%"><span><svg
                    width="1920" height="775" viewBox="0 0 1920 775" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path class="line-1"
                        d="M1922 761.516C1883.55 789.861 1799.69 764.276 1695.5 665.5C1565.26 542.03 1214 420.5 1168.91 537.637C1110.92 688.314 1382.3 703.384 1301.08 462.69C1219.86 221.996 727.193 406.687 337.011 313.758C40.4869 243.135 -26.3152 31.5872 -14.781 1"
                        stroke="#F2F5FA" stroke-width="4" />
                </svg></span></div>
        <div class="shape-mockup movingX d-none d-xl-block" data-top="15%" data-left="5%"><img
                src="assets/img/shape/shape_7.png" alt="shape"/></div>
    </section> */}
    </div>
  )
}

export default Aboutus
